import styled from 'styled-components';
import { theme, toRem } from '../../styles';

export const StyledIcon = styled.span`
  margin-inline-end: ${toRem(10)};
`;

export const StyledSection = styled.section`
  display: flex;
  box-sizing: border-box;
  border-radius: ${toRem(8)};
  margin-bottom: ${toRem(10)};
  padding: ${toRem(12)} ${toRem(20)};
  background-color: ${theme.colors.white};
  &.alert {
    color: ${theme.colors['base-10']};
    border: ${toRem(1)} solid ${theme.colors['close-silver']};
  }
  &.success {
    color: ${theme.colors['merch-green']};
    border: ${toRem(1)} solid ${theme.colors['merch-green']};
  }
  &.success-message,
  &.cancel-success-msg,
  &.success-msg {
    color: ${theme.colors['merch-green']};
    border: ${toRem(1)} solid ${theme.colors['merch-green']};
    margin-bottom: 0;
    margin-top: ${toRem(32)};
    .message {
      color: ${theme.colors['base-10']};
    }
  }
  @media ${theme.mediaQuery.allMobiles} {
    &.success-message,
    &.foreign-currency-alert {
      margin-top: ${toRem(24)};
    }
  }
  &.cancel-success-msg {
    padding: ${toRem(13)} ${toRem(16)};
    align-items: center;
    .message {
      line-height: ${theme.fonts['lineHeightM']};
    }
  }
  &.success-msg {
    margin: ${toRem(24)} 0 ${toRem(4)};
    padding: ${toRem(13)} ${toRem(16)};
  }
  &.alert-error {
    color: ${theme.colors['rose-of-sharon-2']}; //Using Color code as it is not available in global styles.
    border: ${toRem(1)} solid ${theme.colors['rose-of-sharon-2']};
  }
  &.no-redemption-error {
    background-color: ${theme.colors['carousel-pink']};
    color: ${theme.colors.monza};
    border: ${toRem(1)} solid ${theme.colors.monza};
    .message {
      color: ${theme.colors['base-10']};
      & a {
        text-decoration: underline;
      }
    }
    margin-top: ${toRem(32)};
    @media ${theme.mediaQuery.mobileOnly} {
      margin-top: ${toRem(24)};
    }
  }
  &.is-adult-error {
    background-color: ${theme.colors['carousel-pink']};
    color: ${theme.colors.monza};
    border: ${toRem(1)} solid ${theme.colors.monza};
    .message {
      color: ${theme.colors['base-10']};
    }
    margin-top: ${toRem(32)};
    margin-bottom: ${toRem(0)};
    @media ${theme.mediaQuery.tabletOnly} {
      margin-top: ${toRem(32)};
    }
    @media ${theme.mediaQuery.mobileOnly} {
      margin-top: ${toRem(24)};
    }
  }
  &.accessibility-alert {
    background-color: transparent;
    padding: 0;
    margin: ${toRem(0)} ${toRem(27)} ${toRem(16)} ${toRem(0)};
    .message {
      line-height: ${theme.fonts['fontXl']};
    }
    .icon-accessibility {
      &::before {
        height: ${toRem(14)};
        width: ${toRem(11)};
        font-size: ${theme.fonts['fonts']};
      }
    }
  }
  .message {
    margin: 0;
    font-weight: normal;
    font-size: ${theme.fonts['fontS']};
    line-height: ${theme.fonts['fontXxl']};
    & > p {
      margin-bottom: 0;
      & > a {
        color: ${theme.colors['rose-of-sharon-2']};
        text-decoration: underline;
      }
    }
  }
  &.error,
  &.ocj-error,
  &.redemption-panel-error,
  &.redemption-error-msg {
    color: ${theme.colors['rose-of-sharon']};
    border: ${toRem(1)} solid ${theme.colors['rose-of-sharon']};
    .message {
      & a {
        color: ${theme.colors['rose-of-sharon']};
      }
    }
  }
  &.error {
    .message {
      color: ${theme.colors['base-10']};
      & a {
        color: ${theme.colors['base-10']};
      }
    }
  }

  &.redemption-panel-error,
  &.fna-message,
  &.fna-message-alert {
    margin-bottom: 0;
    padding: ${toRem(16)} ${toRem(16)};
    .message {
      font-weight: 500;
      line-height: ${toRem(21)};
      color: ${theme.colors['base-10']};
      & a {
        color: ${theme.colors['base-10']};
      }
    }
    ${StyledIcon} {
      line-height: ${toRem(16)};
      margin-inline-end: ${toRem(8)};
    }
  }

  &.fna-message {
    color: ${theme.colors['salmon']};
    border: ${toRem(1)} solid ${theme.colors['salmon']};
  }

  &.fna-message-alert {
    color: ${theme.colors['base-10']};
    border: ${toRem(1)} solid ${theme.colors['close-silver']};
  }

  &.foreign-currency-alert {
    border: ${toRem(1)} solid ${theme.colors['rose-of-sharon']};
    color: ${theme.colors['rose-of-sharon']};
    .message {
      color: ${theme.colors['base-10']};
    }
    margin-top: ${toRem(32)};
  }
  &.ocj-error {
    margin-top: ${toRem(32)};
    margin-bottom: ${toRem(0)};
  }
  &.redemption-error-msg {
    margin: 0;
    .message {
      line-height: ${theme.fonts['fontXl']};
    }
  }
  &.hotel-message,
  &.hotel-message-mgp {
    color: ${theme.colors['base-10']};
    background-color: transparent;
    border: none;
    border-radius: ${toRem(0)};
    padding: 0;
    .hide-icon {
      display: none;
      margin: 0;
    }
    .message {
      font-size: ${theme.fonts['fontM']};
      line-height: ${theme.fonts['fontXxxl']};
      margin-bottom: 0;
    }
  }
  &.hotel-message-mgp {
    .message {
      position: relative;
      padding-left: ${toRem(15)};
      &:before {
        content: '•';
        position: absolute;
        left: 0;
      }
    }
  }
  &.prearrival-verification {
    color: unset;
    border: ${toRem(1)} solid ${theme.colors['rose-of-sharon']};
    a,
    .message a {
      color: unset;
    }
    .icon-warning {
      color: ${theme.colors['rose-of-sharon']};
    }
  }
  &.modify-restrict,
  &.pref-error {
    color: ${theme.colors['rose-of-sharon']};
    border: ${toRem(1)} solid ${theme.colors['rose-of-sharon']};
    margin: ${toRem(23)} ${toRem(16)} ${toRem(24)};
    padding: ${toRem(13)} ${toRem(16)};
    .message {
      color: ${theme.colors['base-10']};
    }
    .icon-warning {
      height: ${toRem(20)};
      &::before {
        font-weight: ${theme.fonts['fontWeightMedium']};
        font-size: ${theme.fonts['fontL']};
      }
    }
  }
  &.modify-restrict {
    margin: ${toRem(24)} 0 0;
    .message {
      line-height: ${toRem(20)};
    }
  }
  &.failure-message {
    color: ${theme.colors.monza};
    border: ${toRem(1)} solid ${theme.colors.monza};
    margin: ${toRem(32)} 0 0;
    padding: ${toRem(13)} ${toRem(19)};
    height: ${toRem(46)};
    display: flex;
    align-items: center;
    .message {
      color: ${theme.colors['base-10']};
      line-height: ${toRem(20)};
    }
    .icon-warning {
      width: ${toRem(15)};
    }
  }
  &.prepay-rate-alert {
    margin: ${toRem(32)} 0 0;
  }
  &.warning-msg {
    color: ${theme.colors['rose-of-sharon']};
    border: ${toRem(1)} solid ${theme.colors['rose-of-sharon']};
    margin: ${toRem(32)} 0 0;
    .message {
      color: ${theme.colors['base-10']};
      line-height: ${toRem(20)};
    }
  }
  .linktitle {
    border-bottom: ${toRem(1)} solid;
  }
  .icon-external-arrow {
    &::before {
      height: ${toRem(17)};
      width: ${toRem(17)};
    }
  }
  &.upcomingres-alert {
    margin-bottom: ${toRem(16)};
  }
  &.credit-card-alert {
    .message {
      line-height: ${toRem(20)};
    }
    .icon-alert::before {
      line-height: ${toRem(20)};
    }
  }
  &.acrs-member-booking-alert {
    border: ${toRem(1)} solid ${theme.colors['alert-50']};
    background-color: ${theme.colors.white};
    .hide-icon {
      color: ${theme.colors['alert-50']};
    }
    .message {
      padding-top: ${toRem(2)};
      a {
        text-decoration: underline;
      }
    }
  }

  &.price-change-alert {
    border: ${toRem(1)} solid ${theme.colors['light-gray-6']};
    padding: ${toRem(16)};
    .icon-information {
      margin-right: ${toRem(8)};
      margin-top: ${toRem(-4)};
    }
    .message {
      color: ${theme.colors['black']};
      font-weight: ${theme.fonts['fontWeightRegular']};
      line-height: ${toRem(21)};
    }
  }
  &.unavailable-room-alert {
    .icon-warning {
      margin-right: ${toRem(8)};
      margin-top: ${toRem(-4)};
    }
    .message {
      font-weight: ${theme.fonts['fontWeightRegular']};
      line-height: ${toRem(21)};
    }
  }

  .button {
    padding: 0;
    background-color: transparent;
    text-decoration: underline;
    display: block;
    text-align: left;
    text-underline-offset: ${toRem(4)};
  }

  @media ${theme.mediaQuery.tablet} {
    &.pref-error {
      margin: 0;
      margin-bottom: ${toRem(32)};
    }
    &.modify-restrict {
      margin: ${toRem(32)} 0 ${toRem(-24)};
    }
    &.prepay-rate-alert {
      align-items: center;
    }
  }

  @media ${theme.mediaQuery.desktop} {
    &.prepay-rate-alert,
    &.success-message {
      align-items: center;
    }
  }
  @media ${theme.mediaQuery.allMobiles} {
    &.cancel-success-msg,
    &.failure-message {
      margin: 0;
      margin-top: ${toRem(24)};
      align-items: center;
      height: auto;
    }
    &.prepay-rate-alert,
    &.warning-msg {
      margin-top: ${toRem(24)};
    }
    &.upcomingres-alert {
      margin-bottom: ${toRem(12)};
    }
    &.ocj-error {
      margin-top: ${toRem(24)};
    }
  }

  @media ${theme.mediaQuery.desktop} {
    &.icon-block-spacer {
      margin-top: ${toRem(-40)} !important;
    }
  }
`;

export const ImageContainer = styled.span`
  margin-right: ${toRem(24)};
  .image-view {
    height: ${toRem(49)};
    width: ${toRem(80)};
  }

  @media ${theme.mediaQuery.allMobiles} {
    margin-right: 0;
    .image-view {
      display: none;
    }
  }
`;

export const CollapsibleContent = styled.div<{ isExpanded: boolean; shouldCollapse: boolean }>`
  && .message {
    font-weight: 500 !important;
    font-size: ${toRem(14)} !important;
    line-height: ${toRem(21)} !important;
  }
  @media (max-width: 767px) {
    ${props =>
      props.shouldCollapse &&
      !props.isExpanded &&
      `
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      line-height: 1.5;
    `}
  }
`;
